import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { shellKeys } from "./shellSource";
import { useNavigationText } from "./navigation";
export function useShellText() {
  const { t } = useTranslation("shell");
  const navigation = useNavigationText();
  const text = useCallback((source: string): string => {
    if (!Object.prototype.hasOwnProperty.call(shellKeys, source)) return navigation(source);
    return t($ => $[shellKeys[source as keyof typeof shellKeys]]);
  }, [t, navigation]);
  return { text, t };
}
